export default "__VITE_ASSET__f5898268__"